import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { FixedToolMeasurementBuilder } from '../../models/builders/fixed-tool-measurement.builder';
import { FixedToolMeasurement } from '../../models/fixed-tool-measurement';

const fixedToolMeasurementBody = (fixedToolMeasurement: FixedToolMeasurement) => ({
  modelHash: fixedToolMeasurement.modelHash,
  toolHash: fixedToolMeasurement.toolHash,
  toolHolderHash: fixedToolMeasurement.toolHolderHash,
  length: fixedToolMeasurement.length,
  z: fixedToolMeasurement.z,
  x: fixedToolMeasurement.x,
  concentricity: fixedToolMeasurement.concentricity
});

@Injectable()
export class FixedToolMeasurementApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }fixed-tool-measurements`;
  }

  createFixedToolMeasurement(fixedToolMeasurement) {
    return this.httpClient.post(this.apiUrl, fixedToolMeasurementBody(fixedToolMeasurement))
      .pipe(map(FixedToolMeasurementBuilder.fromJson));
  }

  deleteFixedToolMeasurement(fixedToolMeasurement: FixedToolMeasurement) {
    return this.httpClient.delete(`${ this.apiUrl }/${ fixedToolMeasurement.hash }`);
  }

  getFixedToolMeasurement(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(FixedToolMeasurementBuilder.fromJson)
      );
  }

  getFixedToolMeasurements() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(FixedToolMeasurementBuilder.fromList));
  }

  updateFixedToolMeasurement(fixedToolMeasurement: FixedToolMeasurement) {
    return this.httpClient.put(`${ this.apiUrl }/${ fixedToolMeasurement.hash }`, fixedToolMeasurementBody(fixedToolMeasurement));
  }

  getSuggestions(modelHash: string) {
    const params = new HttpParams()
      .append('model', modelHash);

    return this.httpClient.get(`${ this.apiUrl }/suggestions`, { params })
      .pipe(map(FixedToolMeasurementBuilder.fromList));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/fixed-tool-measurement-api.service.ts